export type DisplayContent = {
  title: any;
  text: any;
};

type MessagingModalProps = {
  display: DisplayContent;
  onClose: () => void;
};

export function MessagingModal({ display, onClose }: MessagingModalProps) {
  const { title, text } = display;

  return (
    <div className="space-y-4" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()} 
      >
        <h1 className="font-extrabold">{title}</h1>
        <div className="text-gray-500 font-normal text-base">{text}</div>
      </div>
    </div>
  );
}
